export const isAndroid = () => /Android/i.test(navigator.userAgent);
